import React, { useState, useEffect, useRef } from "react";
import { McBadge } from "@maersk-global/mds-react-wrapper/components-core/mc-badge";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { useNotificationContext } from "./NotificationProvider";
import { NotificationPanel } from "./NotificationPanel";

// Global flag to ensure we only initialize once across all instances
let hasInitialized = false;

export const NotificationButton: React.FC = () => {
  const [panelVisible, setPanelVisible] = useState(false);
  const { unreadCount, searchNotifications } = useNotificationContext();
  const isFirstMount = useRef(true);

  // Initialize unread count when component first mounts
  useEffect(() => {
    if (!isFirstMount.current || hasInitialized) {
      return;
    }

    isFirstMount.current = false;
    hasInitialized = true;

    // Get initial unread count with a small delay to ensure stability
    const timer = setTimeout(async () => {
      try {
        console.log("Getting initial unread count...");
        // Trigger search for unread notifications to get the count
        await searchNotifications({
          page: 0,
          size: 1,
          sort: "id desc",
          isRead: false,
        });
      } catch (error) {
        console.error("Failed to get initial unread count:", error);
      }
    }, 200);

    return () => {
      clearTimeout(timer);
    };
  }, [searchNotifications]);

  return (
    <>
      <McButton
        appearance="neutral"
        variant="plain"
        fit="small"
        label="Notifications"
        hiddenlabel
        icon="bell"
        click={() => setPanelVisible(true)}
        style={{ marginRight: "8px" }}
      >
        {unreadCount > 0 && (
          <McBadge
            slot="badge"
            label={String(unreadCount)}
            appearance="error"
            fit="small"
            display="pinned"
            position="top"
          />
        )}
      </McButton>

      <NotificationPanel visible={panelVisible} onClose={() => setPanelVisible(false)} />
    </>
  );
};
